<template>
  <PullRefresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh" class="refresh-wrap">
    <List
      v-model:loading="loading"
      :finished="finished"
      :finished-text="listData.length ? '没有更多了' : ''"
      @load="onLoad"
    >
      <Empty v-if="!listData.length && !loading" description="暂无数据" />
      <slot v-else :data="listData"></slot>
    </List>
  </PullRefresh>
</template>

<script setup>
import { ref, defineProps, onMounted, defineEmits } from 'vue';
import { List, PullRefresh, showFailToast, Empty } from 'vant';

const PAGESIZE = 10;
const props = defineProps({
  getData: {
    type: Function,
    default: () => new Promise(r => r())
  },
  init: {
    type: Function,
    default: () => {}
  }
})

const page = ref(1);
const loading = ref(false);
const listData = ref([]);
const finished = ref(false);

const refreshing = ref(false);
const onRefresh = () => {
  page.value = 1;
  finished.value = false;
  loading.value = true;
  onLoad();
}

const isFetch = ref(false);
const onLoad = () => {
  if (isFetch.value) return;
  isFetch.value = true;
  props.getData({
    page: page.value,
    pageSize: PAGESIZE
  }).then((res) => {
    const { list: data, total } = res;
    if (page.value === 1) {
      listData.value = [];
    }
    listData.value = listData.value.concat(data);
    loading.value = false;
    refreshing.value = false;
    page.value++;
    if (data.length < PAGESIZE || listData.value.length >= total) {
      finished.value = true;
    }
  }).catch(err => {
    refreshing.value = false;
    showFailToast(err);
  }).finally(() => {
    isFetch.value = false;
  });
};

const emits = defineEmits(['init']);
onMounted(() => {
  emits('init', {
    resetUpScroll: () => onRefresh()
  })
})
</script>

<style lang="scss" scoped>
.refresh-wrap {
  min-height: 60vh;
}
</style>